import { render, staticRenderFns } from "./TitleDetailPosterWithInfo.vue?vue&type=template&id=3dc6e303&scoped=true"
import script from "./TitleDetailPosterWithInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailPosterWithInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailPosterWithInfo.vue?vue&type=style&index=0&id=3dc6e303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6e303",
  null
  
)

export default component.exports